// User-related constants
export const BOT_USER_ID = 'bot';
export const NONE_USER_ID = 'none';
